export default __webpack_public_path__ + "static/media/NURSES.4f4efcee.png";